import { PERFORMS, CONTRIBUTES } from "@/assets/js/tactics/pitch/responsibilities";
import DefensivePressurePerformance from "./performances/central-defence/defensive-pressure";
import PlayingSafePerformance from "./performances/central-defence/playing-safe";
import AttackingCoverPerformance from "./performances/central-defence/attacking-cover";
import DefensiveCoverPerformance from "./performances/central-defence/defensive-cover";


export default class CentralDefenceResponsibilityPerformances {
  constructor() {
    this.defensivePressure = new DefensivePressurePerformance();
    this.playingSafe = new PlayingSafePerformance();
    this.attackingCover = new AttackingCoverPerformance();
    this.defensiveCover = new DefensiveCoverPerformance();
  }

  countPerformance(performances) {
    for (const responsibility of Object.keys(performances)) {

      if (performances[responsibility].performs === PERFORMS) {
        this[responsibility].addPerformer(performances[responsibility].atypically);
        continue;
      }
      if (performances[responsibility].performs === CONTRIBUTES) {
        this[responsibility].addContributor(performances[responsibility].atypically);
      }
    }
  }
}
